import gql from 'graphql-tag';

import type { AllInstructionsData } from 'src/data/generation';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateCopilotDefaults(
    $customerId: ID!
    $workspaceId: ID!
    $tov: JSON
    $sfv: JSON
    $improveKeepStructure: Boolean
  ) {
    updateCopilotDefaults(
      customerId: $customerId
      workspaceId: $workspaceId
      tov: $tov
      sfv: $sfv
      improveKeepStructure: $improveKeepStructure
    ) {
      settings {
        copilotCustomerId
        copilotWorkspaceId
        copilotTov
        copilotSfv
        copilotImproveKeepStructure
      }
    }
  }
`;

interface CopilotDefaultsResult {
  settings: {
    copilotCustomerId?: ID;
    copilotWorkspaceId?: ID;
    copilotTov?: ID;
    copilotSfv?: AllInstructionsData | null;
    copilotImproveKeepStructure?: boolean;
  };
}

export const updateCopilotDefaults = async (
  customerId: ID,
  workspaceId: ID,
  options?: {
    tov?: { defaultPreset: string } | { customId: ID } | null;
    sfv?: AllInstructionsData | null;
    improveKeepStructure?: boolean;
  }
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      customerId,
      workspaceId,
      tov: options?.tov ?? null,
      sfv: options?.sfv ?? null,
      improveKeepStructure: options?.improveKeepStructure ?? null,
    },
  });

  return getSingleProp<CopilotDefaultsResult>(result.data);
};
